var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"darkBlue--text text-h6 text-sm-h5 text-md-h4 font-weight-bold text-wrap"},[_vm._v(" "+_vm._s(_vm.headerTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }